import OptionsToggle  from "./OptionsToggle.component";
import React from "react";
import CompletionMessageComponent from "./CompletionMessage.component";
import { 
  faceidSVGLarge,
  touchidSVGLarge,
  keySVGLarge,
} from "../../../../constants/images";
    

const WebAuthnIconsActiveLarge =  ( 
  <div className="icons-for-webauthn">
      { faceidSVGLarge } {touchidSVGLarge } { keySVGLarge }
  </div>
)


export {
  OptionsToggle,
  WebAuthnIconsActiveLarge,
  CompletionMessageComponent
};
